var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-card',{attrs:{"title":"Grupo"}},[_c('UniqueTable',{attrs:{"data":_vm.data.groups}})],1),_c('b-card',{attrs:{"title":"Cedentes"}},[_c('assignor-table',{attrs:{"data":_vm.data.assignors.map(function (item) { return (Object.assign({}, item,
        item.assignor)); })}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }